import * as React from 'react';

export const Pug = (props: { template: PugTemplate, [key: string]: any }) => {
    const { template, ...locals } = props;
    const html = template(locals);
    return (
        <div dangerouslySetInnerHTML={{ __html: html }} />
    );
};

export class AsyncPugTemplate<T> extends React.PureComponent<{ partial: string } & T> {
    state = { template: null };

    componentDidMount(): void {
        this.import();
    }

    componentDidUpdate(): void {
        this.import();
    }

    render() {
        const { partial, ...props } = this.props;
        const { template } = this.state;
        return template ? <Pug template={template} {...props} /> : <div>loading...</div>;
    }

    private async import() {
        const { partial } = this.props;
        const module = await import('../templates/' + partial + '.pug');
        this.setState({ template: module.default });
    }
}
